export default "__VITE_ASSET__ChwoyecQ__"